import { render, staticRenderFns } from "./EditKPIItem.vue?vue&type=template&id=31a8cdb4&scoped=true&"
import script from "./EditKPIItem.vue?vue&type=script&lang=js&"
export * from "./EditKPIItem.vue?vue&type=script&lang=js&"
import style0 from "./EditKPIItem.vue?vue&type=style&index=0&id=31a8cdb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a8cdb4",
  null
  
)

export default component.exports